export default "__VITE_ASSET__df9b05b8__"